module.exports = __webpack_public_path__ + "media/images/athletes/1524-edbd22180998a5c67da6f44a6c6c871a.png";